import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { colorType } from 'components/common/buttons/Button';
import { DefaultButton } from 'components/styled/Button';

export interface ILinkButton {
  color?: colorType;
  to: string;
  label: string;
  borderRadius?: string;
  onClick?: () => void;
  width?: string;
  margin?: string;
}

export const LinkButton = ({
  color,
  to,
  label,
  borderRadius,
  onClick,
  width,
  margin,
}: ILinkButton) => {
  const { t } = useTranslation();

  return (
    <Link to={to}>
      <DefaultButton
        width={width}
        margin={margin}
        color={color || 'white'}
        borderRadius={borderRadius}
        onClick={onClick}
      >
        {t(label)}
      </DefaultButton>
    </Link>
  );
};
